import { resources } from "@constants/hardcoded-strings";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { GeneralBasicInfoValidationErrors } from "@idw-types/common/validation/verification-service-details-validation-errors";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";

export const getGeneralBasicInfoValidationErrors = (
    rpServiceConfiguration: FormattedRpServiceConfiguration
): GeneralBasicInfoValidationErrors => {
    let count = 0;

    const basicInfoResources = resources.pages.verificationServiceDetails.tabs.general.subTabs.basicInfo;

    let serviceNameError = null;
    if (rpServiceConfiguration.serviceName === "") {
        count += 1;
        serviceNameError = (
            <ErrorAlert>
                <span>{basicInfoResources.inputs.serviceName.validationError}</span>
            </ErrorAlert>
        );
    }

    let apiKeyError = null;
    if (rpServiceConfiguration.apiKey === "") {
        count += 1;
        apiKeyError = (
            <ErrorAlert>
                <span>{basicInfoResources.inputs.apiKey.validationError}</span>
            </ErrorAlert>
        );
    }

    let sharedSecretError = null;
    if (rpServiceConfiguration.sharedSecret === "") {
        count += 1;
        sharedSecretError = (
            <ErrorAlert>
                <span>{basicInfoResources.inputs.sharedSecret.validationError}</span>
            </ErrorAlert>
        );
    }

    return {
        serviceNameError,
        apiKeyError,
        sharedSecretError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={basicInfoResources.tabName} errorCount={count} />
    };
};
